export default "__VITE_ASSET__DAYUCOJe__"